// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IAccountInfo } from './IAccountInfo';
import {
    IAccountInfoFromJSON,
    IAccountInfoFromJSONTyped,
    IAccountInfoToJSON,
    IAccountInfoToJSONTyped,
} from './IAccountInfo';

/**
 * 
 * @export
 * @interface IAddVaultedAccountRequest
 */
export interface IAddVaultedAccountRequest {
    /**
     * 
     * @type {IAccountInfo}
     * @memberof IAddVaultedAccountRequest
     */
    accounts?: IAccountInfo;
}

/**
 * Check if a given object implements the IAddVaultedAccountRequest interface.
 */
export function instanceOfIAddVaultedAccountRequest(value: object): value is IAddVaultedAccountRequest {
    return true;
}

export function IAddVaultedAccountRequestFromJSON(json: any): IAddVaultedAccountRequest {
    return IAddVaultedAccountRequestFromJSONTyped(json, false);
}

export function IAddVaultedAccountRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAddVaultedAccountRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'accounts': json['accounts'] == null ? undefined : IAccountInfoFromJSON(json['accounts']),
    };
}

export function IAddVaultedAccountRequestToJSON(json: any): IAddVaultedAccountRequest {
    return IAddVaultedAccountRequestToJSONTyped(json, false);
}

export function IAddVaultedAccountRequestToJSONTyped(value?: IAddVaultedAccountRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'accounts': IAccountInfoToJSON(value['accounts']),
    };
}

